module.exports = __webpack_public_path__ + "media/images/menu/stars-a1e6441dda77b1d05776cf1778510a0a.jpg";